/**
 * Created by laszlo.czondor on 2017. 08. 31.
 *
 * Gets current domain based on window.location.hostname.
 */

const DOMAIN_REGEX = /\.[a-z0-9\-]*\.[a-z]{2,6}$/i;

function getDomain(){
	let hostname = window.location.hostname;
	let domainMatch = DOMAIN_REGEX.exec(hostname);

	let result = (domainMatch && domainMatch.length > 1) ? domainMatch[1] : hostname;

	return result;
}

export default getDomain;


// WEBPACK FOOTER //
// ../source/common/analytics/get-domain.js